// extracted by mini-css-extract-plugin
export default {"root":"hcx-financial-card-header_root__xnSTt","role":"hcx-financial-card-header_role__V9RTw"};